import React from 'react';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import { translate as t } from '../../lib/I18n';

function Failure () {
    return (
        <div>
            <p className="margin-top--md font-margin-bottom text-weight--normal text-lg text-secondary">{ t('nre.transferModal.failure.sorry') }</p>
            <p className="margin-top--sm text-weight--normal">
                <FormattedHTMLMessage
                    message="nre.transferModal.failure.text"
                    brand={ <span className="text-secondary">{ t('app.owner') }</span> }
                />
            </p>
            <p className="text-weight--normal">{ t('nre.transferModal.failure.text2') }</p>
        </div>
    );
}

export default Failure;



// WEBPACK FOOTER //
// ./src/components/nre/Failure.js